import { openBlock as t, createElementBlock as c, createElementVNode as e } from "vue";
const o = {
  xmlns: "http://www.w3.org/2000/svg",
  viewBox: "0 0 24 24"
}, l = /* @__PURE__ */ e("path", { d: "M12.277 9.45c.385 0 .684.39.656.856l-.234 3.99c-.028.42-.31.745-.656.745h-.093c-.347 0-.628-.326-.656-.744l-.234-3.992c-.028-.465.272-.855.656-.855h.562Zm-.28 6.791c.515 0 .936.419.936.93a.936.936 0 0 1-1.873 0c0-.511.422-.93.937-.93Z" }, null, -1), n = /* @__PURE__ */ e("path", {
  "fill-rule": "evenodd",
  d: "M13.521 3.162c-.67-1.181-2.373-1.181-3.044 0L1.472 19.03c-.662 1.167.18 2.614 1.522 2.614h18.011c1.342 0 2.184-1.447 1.522-2.614L13.521 3.162Zm-1.739.74a.25.25 0 0 1 .435 0l9.006 15.868a.25.25 0 0 1-.218.373H2.994a.25.25 0 0 1-.218-.373l9.006-15.867Z",
  "clip-rule": "evenodd"
}, null, -1), r = [
  l,
  n
];
function d(s, a) {
  return t(), c("svg", o, [...r]);
}
const _ = { render: d };
export {
  _ as default,
  d as render
};
